import React from 'react';

import { Wrapper, Option } from './Options.style'


function Options({ selectOption, options }) {
  
  return (
    <Wrapper>
      {options.map(option => (
        <Option onClick={() => selectOption(option.name)}>
          {option.title}
        </Option>
      ))}
    </Wrapper>
  );
}

export default Options;



// WEBPACK FOOTER //
// ./src/components/Options/Options.component.js